import { createAction, props } from '@ngrx/store';
import { SenderDomain } from '../models';

export const fetchRequest = createAction(
  '[Email] Sender Domain Fetch Request',
  props<{ accountId: string }>(),
);
export const fetchSuccess = createAction(
  '[Email] Sender Domain Fetch Success',
  props<{ senderDomains: SenderDomain[] }>(),
);
export const fetchFailure = createAction('[Email] Sender Domain Fetch Failure');

export const createRequest = createAction(
  '[Email] Sender Domain Create Request',
  props<{
    accountId: string;
    fromDomain: string;
    senderDomain: string;
  }>(),
);
export const createSuccess = createAction(
  '[Email] Sender Domain Create Success',
  props<{ senderDomain: SenderDomain }>(),
);
export const createFailure = createAction(
  '[Email] Sender Domain Create Failure',
);

export const deleteRequest = createAction(
  '[Email] Sender Domain Delete Request',
  props<{ domainId: string; accountId: string }>(),
);
export const deleteSuccess = createAction(
  '[Email] Sender Domain Delete Success',
  props<{ domainId: string }>(),
);
export const deleteFailure = createAction(
  '[Email] Sender Domain Delete Failure',
);
